import { configureStore } from '@reduxjs/toolkit';
import configureHeaderReducer from "../src/Components/Lanes/Slices/ConfigheaderMapSlice";

export const store = configureStore({
  reducer: {
    configureHeader: configureHeaderReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          'configureHeader/setFile',
          'configureHeader/setFormats',
          'configureHeader/setStep',
        ],
        ignoredPaths: [
          'configureHeader.file',
          'configureHeader.formats',
        ],
      },
    }),

});
